import React, {useCallback, useEffect, useState} from 'react';
import classes from "./main.module.css";
import StartBlock from "./startBlock/startBlock";
import Header from "./header/header";
import Bonuses from "./bonuses/bonuses";
import lion1 from '../../../images/lions/lion-1.png'
import lion2 from '../../../images/lions/lion-2.png'
import lion3 from '../../../images/lions/lion-3.png'
import lion4 from '../../../images/lions/lion-4.png'
import lion5 from '../../../images/lions/lion-5.png'
import lion6 from '../../../images/lions/lion-6.png'
import lion7 from '../../../images/lions/lion-7.png'
import Balance from "./balance/balance";
import Button from "./button/button";
import {texts} from "../../../translate";
import Menu from "./menu/menu";
import Referrals from "./referrals/referrals";
import Roadmap from "./roadmap/roadmap";
import Profit from "./profit/profit";
import {getMe, register} from "../../../utils/api";
import {useTelegram} from "../../../hooks/useTelegram";
import Notificate from "./notificate/notificate";
import AddBalance from "./addBalance/addBalance";
import Limit from "./limit/limit";
import Spend from "./spend/spend";
import Wheel from "./wheel/wheel";

const LIONS = [lion1, lion2, lion3, lion4, lion5, lion6, lion7]
const lionSrc = (rank) => LIONS[Math.max(0, Math.min(6, (rank?.index || 1) - 1))]

const formatLimit = (value) => {
    const num = Number(value || 0)
    return num.toLocaleString('ru-RU')
}

const Main = () => {
    const {webApp, langT} = useTelegram()
    const [startBlock, setStartBlock] = useState(true)
    const [openSettings, setOpenSettings] = useState(false)
    const [openInstruction, setOpenInstruction] = useState(false)
    const [balance, setBalance] = useState(0)
    const [active, setActive] = useState(1)
    const [lang, setLang] = useState(langT)
    const [data, setData] = useState()
    const [cryptoAddress, setCryptoAddress] = useState('')
    const [notifyRounds, setNotifyRounds] = useState(true)
    const [timer, setTimer] = useState(0)
    const [notification, setNotification] = useState(0)
    const [openLimit, setOpenLimit] = useState(false)
    const [openSpend, setOpenSpend] = useState(false)
    const [openAddBalance, setOpenAddBalance] = useState(false)

    const onBackClick = useCallback(() => {
        setTimer(Date.now())
    },[])

    useEffect(()=>{
        webApp.BackButton.hide()
        setOpenSettings(false)
        setOpenInstruction(false)
        getMeF()
    },[timer])

    useEffect(()=>{
        if(openSettings){
            webApp.BackButton.show()
        }
    },[openSettings])

    useEffect(()=>{
        if(openInstruction){
            webApp.BackButton.show()
        }
    },[openInstruction])

    useEffect(() => {
        webApp.ready()
        webApp.expand()
        webApp.BackButton.onClick(onBackClick)
        return () => {
            webApp.BackButton.offClick(onBackClick)
        };
    }, [webApp, onBackClick])

    const getMeF = async ()=>{
        const res = await getMe()
        if(!res.error){
            setData(res)
            setBalance(res?.user?.balance)
            setCryptoAddress(res?.user?.crypto_address)
            setNotifyRounds(res?.user?.notify_rounds !== false)
        }
    }

    const registerF = async ()=>{
        const hash = window.location.hash.slice(1);
        const params = new URLSearchParams(hash);
        const tgWebAppData = new URLSearchParams(params.get('tgWebAppData'));
        const inviter_id = tgWebAppData.get('start_param');
        await register(inviter_id)
        await getMeF()
    }

    const inTelegram = Boolean(webApp?.initData)

    useEffect(()=>{
        registerF()
        if (inTelegram) {
            setTimeout(()=>{setStartBlock(false)},5000)
        }
        setInterval(getMeF, 5000)
    },[])

    useEffect(()=>{
        getMeF()
        if(active === 2 || active === 3 || active === 4){
            if(!data?.user.is_active){
                setActive(1)
                setNotification(Date.now());
            }
        }
    },[active])

    useEffect(()=>{
        getMeF()
    },[openAddBalance])

    const isActive = Boolean(data?.user?.is_active)
    const freeSpins = data?.user?.wheel_free_spins || 0
    const openRound = Boolean(data?.open_round)
    const limitValue = data?.limit?.total || 0
    const rank = data?.rank

    const primaryAction = () => {
        if (!isActive) {
            setOpenAddBalance(true)
            return
        }
        if (openRound) {
            setOpenLimit(true)
            return
        }
        if (freeSpins > 0) {
            const fab = document.querySelector('[data-wheel-fab]')
            fab?.click()
            return
        }
        setActive(2)
    }

    const primaryLabel = () => {
        if (!isActive) return texts[lang].button.text1
        if (openRound) return texts[lang].button.text5
        if (freeSpins > 0) return `${texts[lang].button.text4} (${freeSpins})`
        return texts[lang].button.text2
    }

    return (
        <>
            {startBlock && <StartBlock lang={lang} setStartBlock={setStartBlock} inTelegram={inTelegram}/>}
            <div style={{opacity:startBlock?0:1}} className={classes._}>
                <Header lang={lang}
                        setLang={setLang}
                        openSettings={openSettings}
                        setOpenSettings={setOpenSettings}
                        openInstruction={openInstruction}
                        setOpenInstruction={setOpenInstruction}
                        data={data}
                        cryptoAddress={cryptoAddress}
                        notifyRounds={notifyRounds}
                        setNotifyRounds={setNotifyRounds}
                />
                {active === 1 &&
                    <>
                        <Bonuses lang={lang} isActive={isActive} limit={limitValue} onLimit={()=>setOpenLimit(true)}/>
                        <img alt={''} src={lionSrc(rank)} className={classes.background2} onClick={()=>setActive(4)}/>
                        <Balance lang={lang} value={balance}/>
                        {rank && (
                            <div style={{
                                margin: '8px auto 0',
                                width: 'fit-content',
                                fontSize: 11,
                                color: '#E0B15E',
                                border: '1px solid #3A3121',
                                borderRadius: 20,
                                padding: '4px 12px'
                            }}>
                                {texts[lang].button.rank}: {lang==='ru' ? (rank.lion_title || rank.title) : (rank.lion_title_en || rank.title_en)} · {rank.index} / {rank.total}
                                {data?.nft?.title ? ` · ${lang==='ru' ? data.nft.title : data.nft.title_en}` : ''}
                            </div>
                        )}
                        {isActive ? (
                            <>
                                {openRound && (
                                    <Button click={()=>setOpenLimit(true)} active={true} highlight={true}>
                                        {texts[lang].button.text5}
                                    </Button>
                                )}
                                <Button click={()=>setOpenLimit(true)} active={true}>
                                    <span style={{display:'flex', justifyContent:'space-between', width:'100%', padding:'0 8px'}}>
                                        <span>{texts[lang].button.text2}</span>
                                        <span>{formatLimit(limitValue)} {texts[lang].limit.units}</span>
                                    </span>
                                </Button>
                                <div style={{height: 10}}/>
                                <Button click={()=>setActive(2)} active={true}>{texts[lang].button.text3}</Button>
                                <p style={{margin:'4px 18px 0', textAlign:'center', fontSize:12, color:'#E0B15E'}} onClick={()=>setOpenSpend(true)}>
                                    {texts[lang].spend.title}
                                </p>
                            </>
                        ) : (
                            <Button click={primaryAction} active={true}>{primaryLabel()}</Button>
                        )}
                        {!isActive && (
                            <p style={{margin:'8px 18px 0', textAlign:'center', fontSize:11, color:'#8CA0B5', lineHeight:1.5}}>
                                {texts[lang].button.hintGuest}
                            </p>
                        )}
                        <AddBalance lang={lang} openMenu={openAddBalance} setOpenMenu={setOpenAddBalance} onAccepted={getMeF}/>
                        <div style={{height:'78px'}}></div>
                    </>
                }
                {active === 2 &&
                    <>
                        <Bonuses lang={lang} isActive={isActive} limit={limitValue} onLimit={()=>setOpenLimit(true)}/>
                        <img alt={''} src={lionSrc(rank)} className={classes.background2} onClick={()=>setActive(4)}/>
                        <Balance lang={lang} value={balance}/>
                        <Referrals lang={lang} dataMe={data}/>
                    </>
                }
                {active === 3 &&
                    <>
                        <Bonuses lang={lang} isActive={isActive} limit={limitValue} onLimit={()=>setOpenLimit(true)}/>
                        <img alt={''} src={lionSrc(rank)} className={classes.background2} onClick={()=>setActive(4)}/>
                        <Balance lang={lang} value={balance}/>
                        <Profit lang={lang} setBalance={setBalance} balance={balance}/>
                    </>
                }
                {active === 4 &&
                    <Roadmap lang={lang} setActive={setActive} data={data}/>
                }
                <Menu lang={lang} active={active} setActive={setActive}/>
                {isActive && <Wheel
                    lang={lang}
                    balance={balance}
                    setBalance={setBalance}
                    freeSpins={freeSpins}
                    onSpinResult={(res) => {
                        setData((prev) => prev ? {
                            ...prev,
                            user: {
                                ...prev.user,
                                balance: res.balance,
                                wheel_free_spins: res.free_spins,
                            },
                        } : prev)
                    }}
                />}
            </div>
            <Limit lang={lang}
                   data={data}
                   open={openLimit}
                   setOpen={setOpenLimit}
                   setActive={setActive}
                   onSpend={()=>setOpenSpend(true)}
                   onApplied={getMeF}/>
            <Spend
                lang={lang}
                open={openSpend}
                setOpen={setOpenSpend}
                onWheel={() => document.querySelector('[data-wheel-fab]')?.click()}
                onLimit={()=>setOpenLimit(true)}
            />
            <Notificate text={texts[lang].notificate.text2} open={notification}/>
        </>
    );
};

export default Main;
